import { darkTheme } from '@capsicum/common';
import { Image as CapsicumImage } from '@capsicum/common-web';
import styled from 'styled-components';

export const HeadlineText = styled.div`
	${({ theme }) => theme.fonts.headings.display2};
	text-transform: uppercase;
	color: ${darkTheme.colors.text.main.enabled};
	text-align: center;
	margin: ${({ theme }) => theme.spacings.medium} 0 ${({ theme }) => theme.spacings.xxxsmall};
`;

export const HeadlineSupportText = styled.p`
	${({ theme }) => theme.fonts.text.text2};
	color: ${darkTheme.colors.text.main.enabled};
	margin: 0;
	text-align: center;
`;

export const Blue = styled.span`
	color: ${({ theme }) => theme.colors.text.brand.enabled};
`;

export const ImageWrapper = styled.div`
	justify-content: center;
	flex: 1;
	position: relative;
	margin: ${({ theme }) => theme.spacings.xsmall};

	${({ theme }) => theme.breakpoints.queries.above.mobile} {
		margin: 0;
	}
`;

export const Dropline = styled.p`
	${({ theme }) => theme.fonts.text.text3};
	text-align: center;
`;

export const Wrapper = styled.div`
	height: 100%;
	width: 100%;
	justify-content: flex-end;
	display: flex;
	align-items: stretch;
	flex-direction: column;
	padding: ${({ theme }) => `${theme.spacings.xlarge} ${theme.spacings.medium}`};

	${({ theme }) => theme.breakpoints.queries.above.mobile} {
		margin: 0 auto;
		max-width: 400px;
	}
`;

export const CTAWrapper = styled.div`
	margin-top: ${({ theme }) => theme.spacings.medium};
	display: flex;
	justify-content: center;
`;

export const Image = styled(CapsicumImage)`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	object-fit: contain;
`;
